import React from "react";

import ApplicationForm from "../forms/ApplicationForm";

const ApplicationPage = (props) => {
	return (
		<div id="ApplicationPage">
			<ApplicationForm onUpdate={props.onUpdate} onNextStep={props.onNextStep} data={props.data} />
		</div>
	);
}

export default ApplicationPage;


// WEBPACK FOOTER //
// ./src/components/pages/ApplicationPage.js